import { Subject, takeUntil } from 'rxjs';

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'phoenix-list-item-template',
  templateUrl: './list-item-template.component.html',
  standalone: false,
})
export class ListItemTemplateComponent implements OnInit, OnDestroy, OnChanges {
  @Input() expandOnAdd = true;
  @Input() expandable!: boolean;
  @Input() addOnEmpty = false;
  @Input() hideAddButton = false;
  @Input() hideRemoveButton = false;
  @Input() removeButtonPosition: 'center' | 'top' = 'center';
  @Input() removeButtonTooltip = 'Remove item';
  @Input() addButtonTopMargin = false;
  @Input() showItemDividers = false;
  @Input() markDirtyOnRemove = true;

  private _disable!: boolean;

  @Input() set disable(value: boolean) {
    this._disable = value;
    this.hideAddButton = value;
    this.hideRemoveButton = value;
  }
  get disable(): boolean {
    return this._disable;
  }

  @Input() expandedOnCreate = false;
  @Input() itemList!: FormArray;
  @Input() itemTemplateRef!: TemplateRef<{ $implicit: Object }>;
  @Input() headerTemplateRef!: TemplateRef<{ $implicit: Object }>;

  @Output() removeItem: EventEmitter<number> = new EventEmitter();
  @Output() addItem: EventEmitter<any> = new EventEmitter();

  @ViewChildren(MatExpansionPanel)
  expansionPanelList!: QueryList<MatExpansionPanel>;
  destroy$ = new Subject<void>();

  ngOnInit() {
    if (this.addOnEmpty && this.itemList.value.length === 0) {
      this.handleAddItem();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemList']) {
      // Clean up existing subscriptions
      this.destroy$.next();

      // Reinitialize subscriptions
      this.disable = this.itemList.disabled;
      this.itemList.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(status => {
          if (status === 'DISABLED') {
            this.disable = true;
          } else {
            this.disable = false;
          }
        });
    }
  }

  handleAddItem() {
    this.itemList.markAsDirty();
    this.addItem.emit();
    if (this.expandOnAdd && this.expandable) {
      setTimeout(() => {
        this.expansionPanelList.last.open();
      });
    }
  }

  removeClick(e: MouseEvent, index: number) {
    e.stopPropagation();
    if (this.markDirtyOnRemove) {
      this.itemList.markAsDirty();
    }
    this.removeItem.emit(index);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
